import { Attrs, MinzeElement } from 'minze'

export interface LvcCharlieHandsTogetherFullBody {}

export class LvcCharlieHandsTogetherFullBody extends MinzeElement {
  attrs: Attrs = [
    ['width', 225],
    ['height', 225],
  ]
  html = () => `
    <img width="${this.width}" height="${this.height}" src="https://cloud.squidex.io/api/assets/lvc-dev/89c78d55-1811-4634-9fb5-40adbf0b8cb9/loading.png?version=0&auto=true" loading="eager"/>
  `

  css = () => `
    
  `
}
